// extracted by mini-css-extract-plugin
module.exports = {"modal-body":"styles-module__modal-body___3lBDw","modal-email":"styles-module__modal-email___16yL6"};